import {Component} from 'react';

class LargeButtonCard extends Component {
       
    constructor(props) {
        super(props);
        this.state = {
           
        }; 
    }
    
    render() 
    {   
              
    return <>
        <div className="mt-2">
            <button type="button" className="preset-game-button mt-3" 
                onClick={() => this.props.buttonClicked(this.props.itemList.buttonText)}>
                    {this.props.itemList.buttonName}
            </button>
            
        </div>
   
    </>
    }
}

export default LargeButtonCard;